var fns = [];

function startAnimation(fn) {
    fns.push(fn);
    if(fns.length == 1)
        runAnimate();
}

function stopAnimation(fn){
    for(var index in fns){
        if(fns[index] == fn){
            fns.splice(index,1);
            return;
        }
    }
}

function runAnimate(){
    for(var index in fns){
        fns[index]();
    }

    if(fns.length > 0){
        requestAnimationFrame(runAnimate);
    }
}

export default class BeziorCurve{
    constructor(config={}) {
        this.config = config;

        if(!config.p0){
            this.config.p0 = {
                x: 0,
                y: 0
            }
        }

        if(!config.p1){
            this.config.p1 = {
                x: .28,
                y: .99
            }
        }

        var len = 2;

        if(config.p2) len++;

        this.len = len;

        this.config.distance = this.config.to - this.config.from;

        this.fn = this.config.outFn;
        this.onend = this.config.onend;
    }
    calcDistance(timeInterval) {
        if(timeInterval < 0) return 0;

        if(timeInterval > this.config.time)
            timeInterval = this.config.time;

        var totalTime = this.config.time;
        var rate = timeInterval / totalTime;

        var p0 = this.config.p0;
        var p1 = this.config.p1;

        return 3*p0.y*rate*Math.pow(1-rate, 2) 
        + 3*p1.y*Math.pow(rate, 2)*(1 - rate) 
        + Math.pow(rate,3) 
    }

    run(){
        
        var time = new Date();
        var total = this.config.time;

        var outFn = this.fn;

        var fn = ()=>{
            var now = new Date();
            var interval = now - time;

            outFn(interval);
    
            if(interval >= total) stopAnimation(fn);
        }

        startAnimation(fn);   
    }
    calcCurrent(interval){
        var from = this.config.from;
        var distance = this.config.distance;

        return parseInt(from + this.calcDistance(interval) * distance);
    }
    runWithCalc() {
        var time = new Date();

        var from = this.config.from;
        var current = from;

        var to = this.config.to;

        var outFn = this.fn;

        if(!outFn) return;

        var self = this;
    
        var fn = ()=>{
            var now = new Date();

            var interval = now - time;
            current = self.calcCurrent(interval);
    
            outFn(current);
    
            if(parseInt(current) == parseInt(to)
                || interval > self.config.time){
                if(self.onend)
                    self.onend();

                stopAnimation(fn);
            } 
        }
    
        startAnimation(fn);
    }
}


// WEBPACK FOOTER //
// ./src/api/bezier.js


// WEBPACK FOOTER //
// ./src/api/bezier.js